import { render, staticRenderFns } from "./QbStatusCard.vue?vue&type=template&id=4647770a"
import script from "./QbStatusCard.vue?vue&type=script&lang=js"
export * from "./QbStatusCard.vue?vue&type=script&lang=js"
import style0 from "./QbStatusCard.vue?vue&type=style&index=0&id=4647770a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports